import type { LogEntry } from '@/types/log-entry';
import type { Property } from '@/types/property';
import { ConditionsWidget } from './ConditionsWidget';
import { RecentScoutsCard } from './RecentScoutsCard';

// ---------------------------------------------------------------------------
// CollapsibleConditions
//
// ConditionsWidget now has its own smart collapsible header — wrap it without
// an additional CollapsibleWidget shell so it doesn't double-nest.
// ---------------------------------------------------------------------------

interface CollapsibleConditionsProps {
  properties: Property[];
  /** ID of the user's primary property (renamed from defaultPropertyId in M-07). */
  primaryPropertyId: string | null;
}

export function CollapsibleConditions({ properties, primaryPropertyId }: CollapsibleConditionsProps) {
  return (
    <ConditionsWidget properties={properties} primaryPropertyId={primaryPropertyId} />
  );
}

// ---------------------------------------------------------------------------
// CollapsibleRecentScouts
// ---------------------------------------------------------------------------

interface CollapsibleRecentScoutsProps {
  entries: LogEntry[];
  onEntryClick: (id: string) => void;
  onAddClick: () => void;
  /** waypointId → name lookup; unresolved ids fall to "Unmarked spot" (A5). */
  waypointNames?: Record<string, string>;
}

export function CollapsibleRecentScouts({
  entries,
  onEntryClick,
  onAddClick,
  waypointNames,
}: CollapsibleRecentScoutsProps) {
  // DASH-S1: RecentScoutsCard is self-contained — its own F2 Card shell + F3
  // collapsible header. It is NOT nested inside CollapsibleWidget (which would
  // double-nest headers and reintroduce the transform:rotate chevron).
  return (
    <RecentScoutsCard
      entries={entries}
      onEntryClick={onEntryClick}
      onAddClick={onAddClick}
      waypointNames={waypointNames}
    />
  );
}
